import { render, staticRenderFns } from "./payProjectData.vue?vue&type=template&id=8f3437c4&scoped=true&"
import script from "./payProjectData.vue?vue&type=script&lang=js&"
export * from "./payProjectData.vue?vue&type=script&lang=js&"
import style0 from "./payProjectData.vue?vue&type=style&index=0&id=8f3437c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3437c4",
  null
  
)

export default component.exports